import React from "react";
import { Routes, Route } from "react-router-dom";
import { LazyComponentWithSuspense } from "../components/LazyLoader";

// Lazy load all problem components
const ProblemPage = LazyComponentWithSuspense(() => import("../pages/Contest/ProblemPage"));
const ProblemDiscussion = LazyComponentWithSuspense(() =>
  import("../components/CodingContests/ContestProblem/Discussion")
);

export const ProblemRoutes = () => {
  return (
    <Routes>
      <Route path="/:contestId" element={<ProblemPage />} />
      <Route path="/:problemId/discussion" element={<ProblemDiscussion />} />
    </Routes>
  );
};
